import { query } from "./strapi";

export interface PartnerPromoData {
  partnerQuantity: number;
  partnerQuantityText: string;
  title: string;
  text: string;
  buttonText: string;
  buttonUrl: string;
}

/**
 * Fetches partner promo data from the API
 * @returns Promise with partner promo data
 */
export async function getPartnerPromo(): Promise<PartnerPromoData> {
  return query("partner-promo")
    .then((res) => {
      if (!res) {
        throw new Error("Partner promo data not found");
      }
      return {
        partnerQuantity: res.partnerQuantity,
        partnerQuantityText: res.partnerQuantityText,
        title: res.title,
        text: res.text,
        buttonText: res.buttonText,
        buttonUrl: res.buttonUrl,
      };
    })
    .catch((err) => {
      console.error("Error fetching partner promo data:", err);
      // Return default values if API request fails
      return {
        partnerQuantity: 100,
        partnerQuantityText: "Partners",
        title: "Join our growing network of partners",
        text: "Become a partner and grow your business with us",
        buttonText: "Become a Partner",
        buttonUrl: "/become-partner",
      };
    });
}
